import {
  fetchFreightInfo,
  fetchFreightInfoPrevious
} from '@/services/freightInfo'

/**
 * Mutation types of the store
 */

const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */

const state = {
  loading: false,
  info: null,
  infoPrevious: null
}

/**
 * Getters
 */

const getters = {
  hasPreviousTradingRules(state) {
    if (!state.infoPrevious) return false
    return Object.keys(state.infoPrevious).length > 0
  },

  validTradingRules(state) {
    return (
      state.info?.zonePrices &&
      state.info?.zonePrices.length > 0 &&
      (state.info?.zonePrices[0].minimumOrderValueFreeFreight !== undefined ||
        state.info?.zonePrices[0].minimumOrderValueFreeFreightNotApplicable ===
          true) &&
      state.info?.zonePrices[0].minimumOrderValue !== undefined
    )
  }
}

/**
 * Actions
 */

const actions = {
  async fetchFreightInfo({ commit }, supplierId) {
    commit(mutationTypes.FETCHING)

    try {
      const freightInfo = await fetchFreightInfo(supplierId)
      const freightInfoPrevious = await fetchFreightInfoPrevious(supplierId)
      const freightPayload = { freightInfo, freightInfoPrevious }
      commit(mutationTypes.FETCHED, freightPayload)
    } catch (error) {
      console.log(error)
      commit(mutationTypes.FETCHED, [])
    }
  }
}

/**
 * Mutations
 */

const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, freightPayload) {
    state.info = freightPayload.freightInfo
    state.infoPrevious = freightPayload.freightInfoPrevious
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
